import Vue from "vue";
import Vuex from "vuex";
import notification from "./notification";
import constant from "./constant";
import pageState from "./pageState";
import vendor from "./vendor";
import user from "./user";
import environment from "./environment";
import featureFlags from "./featureFlags";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notification,
    constant,
    pageState,
    vendor,
    user,
    environment,
    featureFlags
  }
});
